{
    "AgentOmnichannel_AllowAnsweringConcurrent": "Allow Answering Concurrent Channels:",
    "AgentOmnichannel_Chat_IntegrationType": "Chat Integration Type:",
    "AgentOmnichannel_Chat_IDOnChatSystem": "ID On Chat System:",
    "AgentOmnichannel_Chat_LiveChatAgentID": "Livechat Agent ID:",
    "AgentOmnichannel_Email_IntegrationType": "Email Integration Type:",
    "AgentOmnichannel_Email_EmailAddress": "Email Address:",
    "AgentOmnichannel_Email_IDOnEmailSystem": "ID On Email System:",

    "AgentOmnichannel_Chat_IntegrationTypes_None": "[None]",
    "AgentOmnichannel_Chat_IntegrationTypes_LiveChat": "LiveChat",

    "AgentOmnichannel_Email_IntegrationTypes_None": "[None]",
    "AgentOmnichannel_Email_IntegrationTypes_Pop3": "Email (POP3 & SMTP)",

    "AgentOmnichannel_Email_EmailAddress_Invalid": "Email Address is invalid",

    "NAME": "AgentOmnichannel"
}